import { Directive, Input } from '@angular/core';
import {
  NG_VALIDATORS,
  FormControl,
  ValidatorFn,
  Validator
} from '@angular/forms';

@Directive({
  selector: '[sameStringValidator][ngModel]',
  providers: [
    {
      provide: NG_VALIDATORS,
      useExisting: SameStringValidatorDirective,
      multi: true
    }
  ]
})
export class SameStringValidatorDirective {
  @Input("sameStringValidator") sameStringValidator: string;
  validator: ValidatorFn;

  constructor() {
    this.validator = this.sameStringValidatorFn();
  }

  validate(c: FormControl) {
    return this.validator(c);
  }

  sameStringValidatorFn(): ValidatorFn {
    return (c: FormControl) => {
      if (this.sameStringValidator == c.value) {
        return null;
      } else {
        return {
          sameStringValidator: {
            valid: false
          }
        };
      }
    }
  }
}
